/*域名*/
// export const URL = 'https://mai-zbj-api.ydtg.com.cn';
export const URL = 'https://huo-zbj-api.yd.com.cn';
/*登录地址*/
export const LOGIN = URL + '/index/phone/invitation';
/*敏感词*/
export const MGC = URL + '/index/phone/get_mgc';
/*聊天记录*/
export const CHAT = URL + '/api/ask';

export const HIS = URL + '/api/getVideo?rid=';

export const GETQUESTIONS = URL + '/api/questions?rid=';

export const teamInfo = URL + '/api/teaminfo?rid=';

export const GetZj = URL + '/api/scoreinfo?rid=';

export const PlayToken = URL + '/api/getPlayToken';

export const QuestionList = URL + '/api/questions?rid='





// WEBPACK FOOTER //
// ./src/api/api.js